import { render, staticRenderFns } from "./contract-agent.vue?vue&type=template&id=1b223a5f&scoped=true"
import script from "./contract-agent.vue?vue&type=script&lang=js"
export * from "./contract-agent.vue?vue&type=script&lang=js"
import style0 from "./contract-agent.vue?vue&type=style&index=0&id=1b223a5f&prod&lang=css"
import style1 from "./contract-agent.vue?vue&type=style&index=1&id=1b223a5f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b223a5f",
  null
  
)

export default component.exports